<script setup lang="ts">
import { mdiInformationOutline } from "@mdi/js";
import { Icon, Switch, Tooltip } from "@soft-db/ui";

const enabled = defineModel<boolean>();

defineProps<{
	text: string;
	icon: string;
	disabled?: boolean;
	disabledText?: string;
}>();
</script>

<template>
	<div class="flex justify-between p-1">
		<button class="flex items-center gap-2" :disabled="disabled" @click="enabled = !enabled">
			<div
				class="bg-base-100 rounded-full border p-1"
				:class="enabled ? 'text-success border-success' : 'text-error border-error'"
			>
				<Icon :d="icon" />
			</div>
			<span>{{ text }}</span>
		</button>
		<div class="flex items-center gap-2">
			<Switch v-model="enabled" color="success" :disabled="disabled" />
			<Tooltip v-if="disabled" :tooltip="disabledText">
				<Icon class="text-black dark:text-white" :d="mdiInformationOutline" />
			</Tooltip>
		</div>
	</div>
</template>
